<style lang="scss" type="stylesheet/scss" scoped>
@import "@/assets/var.scss";
.logo-wrapper {
  padding: 26px 0;
  height: 120px;
  box-sizing: border-box;
}

.content {
  padding: 40px 0 0 0;
  .sign-body {
    background: white;
    box-shadow: 0px 17px 21px 0px rgba(236, 236, 236, 0.36);
    border-radius: 5px;
    width: 570px;
    display: block;
    margin: 0 auto;
    padding: 40px 50px 60px;
    box-sizing: border-box;
    .sign-body-title {
      font-size: 26px;
      color: rgb(26, 122, 248);
      line-height: 1.2;
      text-align: center;
      font-weight: bold;
      margin-bottom: 44px;
    }
    .input-wrapper {
      margin-top: 22px;
      border-bottom: solid 1px #eeeeee;
      display: flex;
      padding-bottom: 10px;
      .s-input {
        outline: none;
        border: none;
        font-size: 16px;
        padding: 10px 5px;
        flex: 1;
        &::placeholder {
          color: rgb(153, 153, 153);
        }
      }
      .get-sms {
        width: 140px;
      }
    }
    .next-step {
      width: 100%;
      margin-top: 44px;
      line-height: 2;
    }

    .go-login {
      font-size: 14px;
      color: rgb(153, 153, 153);
      line-height: 1.2;
      margin-top: 11px;
      float: right;
    }
  }
}

.signin-container {
  background: #eff2fa;
  min-height: calc(100vh - 34px);
}
</style>

<template>
  <div class="signin-container">
    <div style="background:white">
      <my-wrapper>
        <div class="logo-wrapper">
          <a :href="$store.state.urls.SHOP_HOME_URL">
            <img src="@/assets/images/logo.png">
          </a>
        </div>
      </my-wrapper>
    </div>

    <div class="content">
      <my-wrapper>
        <div class="sign-body">
          <div class="sign-body-title">找回密码</div>

          <div class="input-wrapper">
            <input type="text"
                   class="s-input"
                   placeholder="手机号"
                   v-model="signForm.phone">
            <el-button class="get-sms"
                       type="primary"
                       :loading="smsLoading"
                       @click="getSms">{{time === 0 ? '获取验证码' : `${time}秒后再次获取`}}</el-button>
          </div>
          <div class="input-wrapper">
            <input type="text"
                   placeholder="验证码"
                   class="s-input"
                   v-model="signForm.sms">
          </div>

          <div class="input-wrapper">
            <input type="password"
                   placeholder="登录密码"
                   class="s-input"
                   v-model="signForm.password">
          </div>

          <div class="input-wrapper">
            <input type="password"
                   placeholder="再次输入登录密码"
                   class="s-input"
                   v-model="signForm.newPassword">
          </div>

          <el-button class="next-step"
                     type="primary"
                     :loading="submitLoading"
                     @click="submitSignin">立即找回</el-button>
          <div>
            <router-link to="/login"
                         class="go-login">已有账号，立即登陆</router-link>
          </div>
        </div>
      </my-wrapper>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { isPhone } from "@/utils/validate";
export default {
  name: "signin",
  data() {
    return {
      submitLoading: false,
      signForm: {
        newPassword: "",  
        password: "",
        phone: "",
        sms: "",
      },
      smsLoading: false,
      time: 0,
    };
  },
  methods: {
    async submitSignin() {
      if (!this.validatePhone()) {
        return;
      }
      if (!this.validateSMS()) {
        return;
      }
      if (!this.signForm.password) {
        this.$notify.warning({
          title: "警告",
          message: "请输入密码",
        });
        return;
      }
      if (this.signForm.password !== this.signForm.newPassword) {
        this.$notify.warning({
          title: "警告",
          message: "两次密码不一致，请重新输入密码",
        });
        return;
      }
      this.submitLoading = true;
      try {
        await this.$axios.post({
          url: "/v1/common/resetPassword",
          data: {
            code: this.signForm.sms,
            mobilePhone: this.signForm.phone,
            password: this.signForm.password,
          },
        });
        this.submitLoading = false;

        this.$notify.success({
          title: "成功",
          message: "密码找回成功",
        });

        this.$router.push({
          name: "Login",
        });
      } catch (error) {
        this.submitLoading = false;
      }
    },
    validateUsername() {
      this.signForm.username = this.signForm.username.trim();
      if (!this.signForm.username) {
        this.$notify.warning({
          title: "警告",
          message: "请输入用户名",
        });
        return false;
      }
      if (
        this.signForm.username.length < 2 ||
        this.signForm.username.length > 8
      ) {
        this.$notify.warning({
          title: "警告",
          message: "用户名在2-8位",
        });
        return false;
      }
      let uname = this.signForm.username.split("");
      for (let i = 0; i < uname.length; i++) {
        let char = uname[i];
        if (
          !(
            /\d/.test(char) ||
            /[a-z]/i.test(char) ||
            /.*[\u4e00-\u9fa5]+.*$/.test(char) ||
            /-|_/g.test(char)
          )
        ) {
          this.$notify.warning({
            title: "警告",
            message: "用户名不允许输入 - 或 _ 以外的特殊字符",
          });
          return false;
        }
      }
      if (/^\d+$/.test(this.signForm.username)) {
        this.$notify.warning({
          title: "警告",
          message: "用户名不能为纯数字",
        });
        return false;
      }

      return true;
    },
    validateSMS() {
      this.signForm.sms = this.signForm.sms.trim();
      if (!this.signForm.sms) {
        this.$notify.warning({
          title: "警告",
          message: "请输入验证码",
        });
        return false;
      }

      return true;
    },
    validatePhone() {
      this.signForm.phone = this.signForm.phone.trim();

      if (!this.signForm.phone) {
        this.$notify.warning({
          title: "警告",
          message: "请输入手机号",
        });
        return false;
      }

      if (!isPhone(this.signForm.phone)) {
        this.$notify.warning({
          title: "警告",
          message: "请输入正确的手机号",
        });
        return false;
      }

      return true;
    },
    async getSms() {
      if (!this.validatePhone()) {
        return;
      }

      this.smsLoading = true;
      await this.$axios.post({
        url: "/v1/common/sms/verification",
        params: {
          phone: this.signForm.phone,
        },
      });
      this.smsLoading = false;

      this.time = 60;

      this.inter = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.inter);
        }
      }, 1000);
    },
    async getSms() {
      if (!this.validatePhone()) {
        return;
      }

      this.smsLoading = true;
      await this.$axios.post({
        url: "/v1/common/sms/verification",
        params: {
          phone: this.signForm.phone,
        },
      });
      this.smsLoading = false;

      this.time = 60;

      this.inter = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.inter);
        }
      }, 1000);
    },
  },
};
</script>
